// Story Vault API client
// Phase 1: owner-scoped notes/photos/audio/video/docs/links across all project types.
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const authHeaders = () => {
  const token = localStorage.getItem("shweebum_token");
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const vaultApi = {
  categories: async () => {
    const r = await axios.get(`${API}/vault/categories`);
    return r.data;
  },

  list: async (filters = {}) => {
    const params = new URLSearchParams();
    Object.entries(filters).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== "") params.append(k, v);
    });
    const r = await axios.get(`${API}/vault/items?${params.toString()}`, { headers: authHeaders() });
    return r.data;
  },

  createText: async (payload) => {
    const r = await axios.post(`${API}/vault/items`, payload, { headers: authHeaders() });
    return r.data;
  },

  uploadFile: async ({ file, kind, category, title, tags = [], project_links = [] }) => {
    const fd = new FormData();
    fd.append("file", file);
    fd.append("kind", kind);
    fd.append("category", category);
    fd.append("title", title || file.name);
    fd.append("tags", JSON.stringify(tags));
    fd.append("project_links", JSON.stringify(project_links));
    const r = await axios.post(`${API}/vault/items/upload`, fd, {
      headers: { ...authHeaders(), "Content-Type": "multipart/form-data" },
    });
    return r.data;
  },

  remove: async (id) => {
    const r = await axios.delete(`${API}/vault/items/${id}`, { headers: authHeaders() });
    return r.data;
  },

  patch: async (id, patch) => {
    const r = await axios.patch(`${API}/vault/items/${id}`, patch, { headers: authHeaders() });
    return r.data;
  },

  // Returns a token-authed download URL safe to put inside <img>/<audio>/<video> src.
  downloadUrl: (id) => {
    const token = localStorage.getItem("shweebum_token");
    return `${API}/vault/items/${id}/download?auth=${encodeURIComponent(token || "")}`;
  },

  usage: async () => {
    const r = await axios.get(`${API}/vault/usage`, { headers: authHeaders() });
    return r.data;
  },
};
